export const FEATURE_NAME = 'alerts';

export const SUCCESS = 'success';
export const ERROR = 'error';
export const LOADING = 'loading';

export const META = 'meta';
export const TASK_ID = 'taskId';
